// Rasenwelt Sale Countdown Timer — rasenwelt.de
// Asset file: sale-countdown.js

(function () {
  var banner = document.getElementById('rw-sale-banner');
  if (!banner) return;

  var endDate = new Date(banner.dataset.enddate);
  if (isNaN(endDate.getTime())) return;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var now  = new Date();
    var diff = endDate - now;

    if (diff <= 0) {
      document.getElementById('rwCountdown').style.display = 'none';
      document.getElementById('rwExpired').style.display = 'inline';
      clearInterval(timer);
      return;
    }

    var days  = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var mins  = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var secs  = Math.floor((diff % (1000 * 60)) / 1000);

    document.getElementById('rwDays').textContent  = pad(days);
    document.getElementById('rwHours').textContent = pad(hours);
    document.getElementById('rwMins').textContent  = pad(mins);
    document.getElementById('rwSecs').textContent  = pad(secs);
  }

  tick();
  var timer = setInterval(tick, 1000);

})();
